import styled from 'styled-components';

import {
    NewReleaseAllProducts,
    NewReleaseDashboard,
    NewReleaseForecasting,
    NewReleaseMulti,
    NewReleaseReporting,
    NewReleaseSustain,
} from '../../../../packages/icons';

const iconWidth = '18px';

export const StyledNewReleaseAllProducts = styled(NewReleaseAllProducts)`
    display: inline-block;
    height: ${iconWidth};
    width: ${iconWidth};
`;

export const StyledNewReleaseDashboard = styled(NewReleaseDashboard)`
    display: inline-block;
    height: ${iconWidth};
    width: ${iconWidth};
`;

export const StyledNewReleaseForecasting = styled(NewReleaseForecasting)`
    display: inline-block;
    height: ${iconWidth};
    width: ${iconWidth};
`;

export const StyledNewReleaseMulti = styled(NewReleaseMulti)`
    display: inline-block;
    height: ${iconWidth};
    width: ${iconWidth};
`;

export const StyledNewReleaseReporting = styled(NewReleaseReporting)`
    display: inline-block;
    height: ${iconWidth};
    width: ${iconWidth};
`;

export const StyledNewReleaseSustain = styled(NewReleaseSustain)`
    display: inline-block;
    height: ${iconWidth};
    width: ${iconWidth};
`;
